import { Card } from 'components/common'

export function FeedbackPage(): JSX.Element {
  return (
    <div className='c-page'>
      <Card variant='1'>
        <h1>Send feedback</h1>
      </Card>
    </div>
  )
}
